import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
// import logoImage from '../assets/Image/rmsLogo.jpg';
import logoImage from "../assets/Image/rmsLogo.jpg";
import Motor from "../assets/Image/Motor.svg";
import Travel from "../assets/Image/Travel.svg";
import Health from "../assets/Image/Health.svg";
import DomesticWorker from "../assets/Image/ddddd.svg";
import Home from "../assets/Image/home.svg";
import Life from "../assets/Image/life.svg";
import cyber from "../assets/Image/cyber.svg";
import { useTranslatableData } from "../Shared/useTranslatableData";
import "./productAndService.scss";

const ProductAndServices = () => {
  // const navigate = useNavigate();

  // Define static product data
  const products = [
    { id: 1, name: "Vehicle Insurance", image: Motor, route: "/motor" },
    {
      id: 2,
      name: "Travel insurance",
      // subName: "(Coming Soon...)",
      image: Travel,
      // route: "http://45.64.107.162:7000",
    },
    {
      id: 3,
      name: "Home insurance",
      subName: "",
      image: Home,
      route: "/home",
    },
    {
      id: 4,
      name: "Domestic Worker",
      subName: "",
      image: DomesticWorker,
      route: "/DHLF",
    },

    // {
    //   id: 5,
    //   name: " Life Insurance (Coming Soon...)",
    //   subName: "",
    //   image: Life,
    //   route: "/life",
    // },
    // {
    //   id: 6,
    //   name: "Cyber Insurance (Coming Soon...)",
    //   subName: "",
    //   image: cyber,
    //   route: "/cyber",
    // },
  ];

  const text = {
    title: "Select Product",
    // desc: "Please select the insurance product you wish to proceed with to complete your application.",
    desc: "Please select the insurance product you would like to proceed with to complete your application.",
  };

  // Translatable hook
  const { translatedData } = useTranslatableData({
    dataMap: { products, text },
  });

  // Fallbacks if translation not available yet
  const productData = translatedData?.products || [];
  const textData = translatedData?.text || {};

  // Handle product selection
  const handleSelectedProduct = (product) => {
    console.log("product<><>", product);
    if (product?.id === 1) {
      // navigate(ROUTES_NAVIGATION.ADD_DETAILS);
      // createSecureUID();
      // window.location = `${process.env.REACT_APP_MOTOR}?clearLS=true`;
      // window.open(`${process.env.REACT_APP_MOTOR}?clearLS=true`, "_blank");
      window.open(`${process.env.REACT_APP_MOTOR}?clearLS=true`, "_self");

      localStorage.clear();
      console.log("localStorage clear for motor");
    }
    if (product?.id === 2) {
      // window.location = `${process.env.REACT_APP_TAVEL}?clearLS=true`;
      // window.open(`${process.env.REACT_APP_TAVEL}?clearLS=true`, "_blank");
      window.open(`${process.env.REACT_APP_TAVEL}?clearLS=true`, "_self");

      localStorage.clear();
      return; // Early return to avoid setting localStorage for external redirect
    }
    if (product?.id === 3) {
      // window.location = `${process.env.REACT_APP_TAVEL}?clearLS=true`;
      // window.open(`${process.env.REACT_APP_TAVEL}?clearLS=true`, "_blank");
      window.open(`${process.env.REACT_APP_HOME}?clearLS=true`, "_self");

      localStorage.clear();
      return; // Early return to avoid setting localStorage for external redirect
    }
    if (product?.id === 4) {
      // window.location = `${process.env.REACT_APP_HOME}?clearLS=true`;
      window.open(`${process.env.REACT_APP_DHLF}?clearLS=true`, "_blank");
      localStorage.clear();
      return;
    }
    // if (product?.id === 4) {
    //   // Use window.location.href for external URLs
    //   // window.open("http://45.64.107.162:7000/", "_blank");
    //   // window.open("http://45.64.107.162:7000");
    //   localStorage.clear();
    //   window.location = process.env.REACT_APP_HOME;
    //   return; // Early return to avoid setting localStorage for external redirect
    // }
    // const tabKey = 'portal_tab_opened';
    // localStorage.setItem("tabKey", "portal_tab_opened");
    // saveToStorage("portal_tab_opened", LocalStorageKey.TAB_KEY);
  };

  // Clear storage on initial mount
  useEffect(() => {
    localStorage.clear();
  }, []);

  // Sync language changes across tabs
  // useSyncLanguage(setCurrentLang);

  useEffect(() => {
    console.log("HOME PAGE **", productData, textData);
  }, [productData, textData]);

  return (
    <div className="container text-center mt-5 img">
      <div className="mb-4">
        <img src={logoImage} alt="rms logo" className="logo-img" />
      </div>

      {/* Header Text */}
      <div className="Header">
        <h4>{textData?.title || text.title}</h4>
        <h6>{textData?.desc || text.desc}</h6>
      </div>

      {/* Products Grid */}
      <div className="row p-3">
        {productData.length > 0 &&
          (productData || []).map((product) => (
            <div key={product.id} className="col-12 col-sm-6 col-md-6 mb-3">
              <div
                className="product-card p-1 d-flex align-items-center"
                onClick={() => handleSelectedProduct(product)}
              >
                <img
                  src={product.image}
                  alt={product.name}
                  className="product-image"
                />
                <h5 className="service-name">{product.name}</h5>
                {product.subName ? (
                  <h6 className="service-name">{product.subName}</h6>
                ) : null}
              </div>
            </div>
          ))}

        {productData.length === 0 && (
          <div className="text-center w-100">Loading products...</div>
        )}
      </div>
    </div>
  );
};

export default ProductAndServices;
